export default "__VITE_ASSET__DzlS68s8__"